import {useEffect, useState} from 'react';
import {useTransactionEntries} from '../queries/use-paginated-entries';
import {AddFunds} from '@app/drive/share-dialog/amount-add-form';

export function TransactionsTable() {
  const [params, setParams] = useState<any>({});
  const {data, isLoading, refetch} = useTransactionEntries(params);
  const [openAddFunds, setOpenAddFunds] = useState(false);
  const windowParams = new URLSearchParams(window.location.search);
  const sessionId = windowParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      setOpenAddFunds(true);
    }
  }, [sessionId]);

  useEffect(() => {
    if (!openAddFunds) {
      refetch();
    }
  }, [isLoading, openAddFunds, refetch]);

  console.log('Transactions Data:', data);

  return (
    <>
      {openAddFunds ? (
        <AddFunds setOpen={setOpenAddFunds} sessionId={sessionId} />
      ) : (
        <div className="flex h-full flex-col">
          {/* Header */}
          <div className="flex h-60 items-center gap-20 border-b px-8 py-4 md:px-26">
            <h1 className="text-lg font-semibold">Transactions</h1>
            <div className="ml-auto">
              <button
                className="rounded bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark"
                onClick={() => setOpenAddFunds(true)}
              >
                Add Funds
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="stable-scrollbar relative flex-auto overflow-y-auto">
            <div className="p-16 text-center">
              {data && data.length > 0 ? (
                <div className="overflow-auto rounded-2xl shadow-lg mb-20">
                  <table className="w-full table-auto border-collapse border p-10">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="border-b px-14 py-10 text-center">Date</th>
                        <th className="border-b px-14 py-10 text-center">Type</th>
                        <th className="border-b px-14 py-10 text-center">Operation</th>
                        <th className="border-b px-14 py-10 text-center">Amount</th>
                        <th className="border-b px-14 py-10 text-left">Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((entry: any, index: number) => (
                        <tr
                          key={entry.id || index}
                          className={`hover:bg-gray-100 cursor-pointer transition-colors duration-150 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} ${index === data.length - 1 ? 'last:border-b-0' : ''}`}
                        >
                          <td className="border-b px-14 py-10 text-center text-sm text-gray-900">
                            {entry.date ? new Date(entry.date).toLocaleDateString() : 'N/A'}
                          </td>
                          <td className="border-b px-14 py-10 text-center text-sm">
                            <span
                              className={`inline-flex px-8 py-4 text-xs font-semibold rounded-full ${
                                entry.type === 'Credit'
                                  ? 'bg-green-100 text-green-800'
                                  : 'bg-red-100 text-red-800'
                              }`}
                            >
                              {entry.type}
                            </span>
                          </td>
                          <td className="border-b px-14 py-10 text-center text-sm text-gray-900">
                            {entry.operation || 'N/A'}
                          </td>
                          <td className="border-b px-14 py-10 text-center text-sm font-medium">
                            <span
                              className={
                                entry.type === 'Credit'
                                  ? 'text-green-600'
                                  : 'text-red-600'
                              }
                            >
                              {entry.type === 'Credit' ? '+' : '-'}£{entry.amount}
                            </span>
                          </td>
                          <td className="border-b px-14 py-10 text-left text-sm text-gray-900">
                            {entry.note || 'No note'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="flex h-screen items-center justify-center px-4">
                  <div className="border-gray-300 w-full max-w-sm rounded-2xl border bg-white p-50 text-center shadow-xl">
                    <div className="mb-6">
                      <svg
                        className="mx-auto h-24 w-24 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-700 text-xl font-semibold mb-2">
                      No transactions
                    </p>
                    <p className="text-gray-500 text-sm">
                      You have not added any transactions yet
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
